/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ObservationType {
  RespiratoryRateInstant = 'RespiratoryRate_Instant',
  BpRiskScoreInstant = 'BPRiskScore_Instant',
  BpSystolicEstimateInstant = 'BPSystolic_Estimate_Instant',
  BpDiastolicEstimateInstant = 'BPDiastolic_Estimate_Instant',
  BloodOxygenLevelSpo2Instant = 'BloodOxygenLevelSPO2_Instant',
  HeartStressIndexInstant = 'HeartStressIndex_Instant',
  CardiacOutInstant = 'CardiacOut_Instant',
  CardiacWorkloadInstant = 'CardiacWorkload_Instant',
  CardiovascularDiseaseRiskInstant = 'CardiovascularDiseaseRisk_Instant',
  DiabetesRiskProbInstant = 'DiabetesRiskProb_Instant',
  HemoglobinHba1CRiskInstant = 'HemoglobinHBA1CRisk_Instant',
  HypercholesterolemiaRiskInstant = 'HypercholesterolemiaRisk_Instant',
  HyperTentionRiskProbInstant = 'HyperTentionRiskProb_Instant',
  HypertriglyceridemiaRiskProbInstant = 'HypertriglyceridemiaRiskProb_Instant',
  FastingBloodGlucoseRiskInstant = 'FastingBloodGlucoseRisk_Instant',
  FattyLiverDiseaseRiskInstant = 'FattyLiverDiseaseRisk_Instant',
  WaistCircumInCmInstant = 'WaistCircumInCm_Instant',
  HeightInCmInstant = 'HeightInCm_Instant',
  BodyMassIndexInstant = 'BodyMassIndex_Instant',
  WeightInKgInstant = 'WeightInKg_Instant',
  BodyShapeIndexInstant = 'BodyShapeIndex_Instant',
  WaistToHeightInstant = 'WaistToHeight_Instant',
  HeartAttackRiskInstant = 'HeartAttackRisk_Instant',
  StrokeRiskInstant = 'StrokeRisk_Instant',
  VascularCapacityInstant = 'VascularCapacity_Instant',
  MeanArterialPressureInstant = 'MeanArterialPressure_Instant',
  Vo2MaxInstant = 'VO2Max_Instant',
  HeartRateInstant = 'HeartRate_Instant',
  HeartRateVariabilitySdnnInstant = 'HeartRateVariabilitySDNN_Instant',
  MentalScoreInstant = 'MentalScore_Instant',
  MentalStressIndexInstant = 'MentalStressIndex_Instant',
  HeartRateVariabilityRmssdInstant = 'HeartRateVariabilityRMSSD_Instant',
  ActivityDurationSecondsInstant = 'ActivityDurationSeconds_Instant',
  ActivityTotalEnergyKcalInstant = 'ActivityTotalEnergyKcal_Instant',
  ActivityTotalDistanceMetersInstant = 'ActivityTotalDistanceMeters_Instant',
  ActivityRestSecondsInstant = 'ActivityRestSeconds_Instant',
  ActivityActiveSecondsInstant = 'ActivityActiveSeconds_Instant',
  ActivityAverageHeartRateInstant = 'ActivityAverageHeartRate_Instant',
  ActivityMinHeartRateInstant = 'ActivityMinHeartRate_Instant',
  ActivityMaxHeartRateInstant = 'ActivityMaxHeartRate_Instant',
  ActivityDistanceStepsInstant = 'ActivityDistanceSteps_Instant',
  SleepDurationAggregate = 'SleepDuration_Aggregate',
  SleepTimeInBedSecondsAggregate = 'SleepTimeInBedSeconds_Aggregate',
  SleepCoreSleepSecondsAggregate = 'SleepCoreSleepSeconds_Aggregate',
  SleepRemSleepSecondsAggregate = 'SleepRemSleepSeconds_Aggregate',
  SleepDeepSleepSecondsAggregate = 'SleepDeepSleepSeconds_Aggregate',
  SleepTimeAwakeDuringSleepSecondsAggregate = 'SleepTimeAwakeDuringSleepSeconds_Aggregate',
  BloodGlucoseMgPerDeciliterInstant = 'BloodGlucoseMgPerDeciliter_Instant',
  DailyTotalStepsAggregate = 'DailyTotalSteps_Aggregate',
  DailyTotalActiveTimeSecondsAggregate = 'DailyTotalActiveTimeSeconds_Aggregate',
  DailyAverageBloodGlucoseMgPerDeciliterAggregate = 'DailyAverageBloodGlucoseMgPerDeciliter_Aggregate',
  DailyTotalDistanceMetersAggregate = 'DailyTotalDistanceMeters_Aggregate',
  DailyTotalDistanceFloorsAggregate = 'DailyTotalDistanceFloors_Aggregate',
  DailyAverageOxygenationSaturationsAggregate = 'DailyAverageOxygenationSaturations_Aggregate',
  DailyAverageVo2MaxAggregate = 'DailyAverageVo2Max_Aggregate',
  DailyTotalCaloriesExpenditureAggregate = 'DailyTotalCaloriesExpenditure_Aggregate',
  DailyTotalCaloriesActiveAggregate = 'DailyTotalCaloriesActive_Aggregate',
  DailyTotalCaloriesBmrAggregate = 'DailyTotalCaloriesBmr_Aggregate',
  DailyHeartRateMaxAggregate = 'DailyHeartRateMax_Aggregate',
  DailyHeartRateMinAggregate = 'DailyHeartRateMin_Aggregate',
  DailyAverageHeartRateAggregate = 'DailyAverageHeartRate_Aggregate',
  DailyAverageHeartRateRestingAggregate = 'DailyAverageHeartRate_Resting_Aggregate',
  DailyAverageHeartRateRestingMinAggregate = 'DailyAverageHeartRate_Resting_Min_Aggregate',
  DailyAverageHeartRateRestingMaxAggregate = 'DailyAverageHeartRate_Resting_Max_Aggregate',
  DailyAverageHeartRateVariabilitySdnnAggregate = 'DailyAverageHeartRate_Variability_Sdnn_Aggregate',
  SmokingInstant = 'Smoking_Instant',
  DiabetesInstant = 'Diabetes_Instant',
  BodyFatPercentageInstant = 'BodyFatPercentage_Instant',
  ActivityScore = 'Activity_Score',
  FatigueScore = 'FatigueScore',
  SleepScore = 'Sleep_Score',
  StressScore = 'Stress_Score',
  LongevityScore = 'Longevity_Score',
  DailyMinBloodGlucoseMgPerDeciliterAggregate = 'DailyMinBloodGlucoseMgPerDeciliter_Aggregate',
  DailyMaxBloodGlucoseMgPerDeciliterAggregate = 'DailyMaxBloodGlucoseMgPerDeciliter_Aggregate',
  DailyAverageSystolicBloodPressureAggregate = 'DailyAverageSystolicBloodPressure_Aggregate',
  DailyAverageDiastolicBloodPressureAggregate = 'DailyAverageDiastolicBloodPressure_Aggregate',
  DailyMinSystolicBloodPressureAggregate = 'DailyMinSystolicBloodPressure_Aggregate',
  DailyMinDiastolicBloodPressureAggregate = 'DailyMinDiastolicBloodPressure_Aggregate',
  DailyMaxSystolicBloodPressureAggregate = 'DailyMaxSystolicBloodPressure_Aggregate',
  DailyMaxDiastolicBloodPressureAggregate = 'DailyMaxDiastolicBloodPressure_Aggregate',
  BpSystolicVerifiedInstant = 'BPSystolic_Verified_Instant',
  BpDiastolicVerifiedInstant = 'BPDiastolic_Verified_Instant',
  HadsAnxietyScore = 'HADS_Anxiety_Score',
  HadsDepressionScore = 'HADS_Depression_Score',
  HadsTotalScore = 'HADS_Total_Score',
  Phq9TotalScore = 'PHQ9_Total_Score',
  Phq9SuicidalIdeationScore = 'PHQ9_SuicidalIdeation_Score',
  Gad7TotalScore = 'GAD7_Total_Score',
  FindriscTotalScore = 'FINDRISC_Total_Score',
  T2DRiskTotalScore = 'T2DRisk_Total_Score',
  SleepMinHeartRateBpmAggregate = 'SleepMinHeartRateBPM_Aggregate',
  SleepMaxHeartRateBpmAggregate = 'SleepMaxHeartRateBPM_Aggregate',
  SleepAverageHeartRateBpmAggregate = 'SleepAverageHeartRateBPM_Aggregate',
  SleepMinHeartRateVariabilitySdnnAggregate = 'SleepMinHeartRateVariabilitySDNN_Aggregate',
  SleepMaxHeartRateVariabilitySdnnAggregate = 'SleepMaxHeartRateVariabilitySDNN_Aggregate',
  SleepAverageHeartRateVariabilitySdnnAggregate = 'SleepAverageHeartRateVariabilitySDNN_Aggregate',
  BloodOxygenLevelSpo2VerifiedInstant = 'BloodOxygenLevelSPO2_Verified_Instant',
  Vo2MaxVerifiedInstant = 'VO2Max_Verified_Instant',
  BodyMassIndexEstimate = 'BodyMassIndex_Estimate',
  AgeInYearsInstant = 'AgeInYears_Instant',
  QuestionnaireDailyWellnessScore = 'Questionnaire_DailyWellnessScore',
  SmokingRiskInstant = 'SmokingRisk_Instant',
  QuestionnaireBetterWithHeartIndex = 'Questionnaire_BetterWithHeartIndex',
  BowelCancerRiskQuestionnaire = 'BowelCancerRisk_Questionnaire',
  BreastCancerRiskQuestionnaire = 'BreastCancerRisk_Questionnaire',
  CervicalCancerRiskQuestionnaire = 'CervicalCancerRisk_Questionnaire',
  LungCancerRiskQuestionnaire = 'LungCancerRisk_Questionnaire',
  ProstateCancerRiskQuestionnaire = 'ProstateCancerRisk_Questionnaire',
  WorkAbsenteeismScoreQuestionnaire = 'WorkAbsenteeismScore_Questionnaire',
  WorkPresenteeismScoreQuestionnaire = 'WorkPresenteeismScore_Questionnaire',
  WorkPerformanceScoreQuestionnaire = 'WorkPerformanceScore_Questionnaire',
  WorkProductivityScoreQuestionnaire = 'WorkProductivityScore_Questionnaire',
  LifestyleCancerRiskQuestionnaire = 'Lifestyle_Cancer_Risk_Questionnaire',
  SkinCancerRiskQuestionnaire = 'SkinCancerRisk_Questionnaire',
  QuestionnaireGeneralWellnessScore = 'Questionnaire_GeneralWellnessScore',
  MetabolicRiskScoreQuestionnaire = 'MetabolicRiskScore_Questionnaire'
}
